import { render } from "./OurportfolioAssets.vue?vue&type=template&id=33cebff8&scoped=true"
import script from "./OurportfolioAssets.vue?vue&type=script&lang=js"
export * from "./OurportfolioAssets.vue?vue&type=script&lang=js"

import "./OurportfolioAssets.vue?vue&type=style&index=0&id=33cebff8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33cebff8"]])

export default __exports__